module.exports = __webpack_public_path__ + "static/media/protoIcon.6f3c2778.svg";